import React, { useState } from "react";
import Navbar from "../../components/Navbar";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import edit_pencil_icon from "../../assets/icons/edit_pencil_icon.png";
import SubscriptionHistoryCard from "./Components/SubscriptionHistoryCard";
import SubscriptionHistoryModal from "./Components/SubscriptionHistoryModal";
import SuperAdminSearchBar from "./Components/SuperAdminSearchBar";

const SubscriptionHistory = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const [SubHistoryModal, setSubHistoryModal] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  const [hoverActiveOne, setHoverActiveOne] = useState(false);
  const [hoverActiveTwo, setHoverActiveTwo] = useState(false);
  const [hoverActiveThree, setHoverActiveThree] = useState(false);

  const handleHoverOne = () => {
    setHoverActiveOne(!hoverActiveOne);
  };
  const handleHoverTwo = () => {
    setHoverActiveTwo(!hoverActiveTwo);
  };
  const handleHoverThree = () => {
    setHoverActiveThree(!hoverActiveThree);
  };
  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SuperAdminSearchBar
            categoryName="Payment Details"
            route="/super-admin/payment-details"
          />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="ml-4 mt-10">
        <p className="text-[18px]">Payment Detail</p>
      </div>

      <div className="w-full flex justify-center mt-11">
        <div className="w-[95%] flex justify-between plans">
          {/* First Plan */}
          <div
            className={`w-[30%] flex justify-center flex-col items-center shadow-md rounded-lg plan--card ${
              hoverActiveOne ? "cardHover" : ""
            }`}
            onMouseEnter={handleHoverOne}
            onMouseLeave={handleHoverOne}
          >
            <div className="flex justify-around w-full">
              <p
                className={`text-[18px] text-[#333333] font-bold mt-5 mb-4 ${
                  hoverActiveOne ? "text-white" : ""
                }`}
              >
                Essential Exhibitor Package
              </p>
              <img
                src={edit_pencil_icon}
                alt="edit"
                className="w-4 object-contain"
              />
            </div>

            <div className="bg-[#F0F0F0] w-full text-[24px] font-bold pl-2 py-1 text-black">
              $300
              <span className="pl-1 text-[#746E7B] text-[20px]">/month</span>
            </div>
            <div
              className={`items-center text-[#828282] text-[16px] w-[70%] justify-start py-4 ${
                hoverActiveOne ? "text-white" : ""
              }`}
            >
              Medium-sized exhibitors seeking post-exhibition management.
            </div>
          </div>

          {/* Second Plan */}
          <div
            className={`w-[30%] flex justify-center flex-col items-center shadow-md rounded-lg plan--card ${
              hoverActiveTwo ? "cardHover" : ""
            }`}
            onMouseEnter={handleHoverTwo}
            onMouseLeave={handleHoverTwo}
          >
            <div className="flex justify-around w-full">
              <p
                className={`text-[18px] text-[#333333] font-bold mt-5 mb-4 ${
                  hoverActiveTwo ? "text-white" : ""
                }`}
              >
                Organizer Pro
              </p>
              <img
                src={edit_pencil_icon}
                alt="edit"
                className="w-4 object-contain"
              />
            </div>
            <div className="bg-[#F0F0F0] w-full text-[24px] font-bold pl-2 py-1 text-black">
              $500
              <span className="pl-1 text-[#746E7B] text-[20px]">/month</span>
            </div>
            <div
              className={`items-center text-[#828282] text-[16px] w-[70%] justify-start py-4  ${
                hoverActiveTwo ? "text-white" : ""
              }`}
            >
              Event organizers in need of comprehensive post-exhibition
              solutions for multiple exhibitors.
            </div>
          </div>

          {/* Third Plan */}
          <div
            className={`w-[30%] flex justify-center flex-col items-center shadow-md rounded-lg plan--card ${
              hoverActiveThree ? "cardHover" : ""
            }`}
            onMouseEnter={handleHoverThree}
            onMouseLeave={handleHoverThree}
          >
            <div className="flex justify-around w-full">
              <p
                className={`text-[18px] text-[#333333] font-bold mt-5 mb-4 ${
                  hoverActiveThree ? "text-white" : ""
                }`}
              >
                Enterprise Empowerment
              </p>
              <img
                src={edit_pencil_icon}
                alt="edit"
                className="w-4 object-contain"
              />
            </div>
            <div className="bg-[#F0F0F0] w-full text-[24px] font-bold pl-2 py-1 text-black">
              $500
              <span className="pl-1 text-[#746E7B] text-[20px]">/month</span>
            </div>
            <div
              className={`items-center text-[#828282] text-[16px] w-[70%] justify-start py-4 ${
                hoverActiveThree ? "text-white" : ""
              }`}
            >
              Event organizers in need of comprehensive post-exhibition
              solutions for multiple exhibitors.
            </div>
          </div>
        </div>
      </div>

      <div className="mt-10 ml-4">
        <button className="py-2 px-10 border border-[#2F80ED] rounded-lg text-[14px] font-bold text-[#2F80ED]">
          Add new plans
        </button>
      </div>

      <div className="ml-4 mt-10">
        <p className="text-[18px]">Client Subscription History</p>
      </div>

      <div className="ml-4 my-10">
        <SubscriptionHistoryCard setSubHistoryModal={setSubHistoryModal} />
        <SubscriptionHistoryCard setSubHistoryModal={setSubHistoryModal} />
        <SubscriptionHistoryCard setSubHistoryModal={setSubHistoryModal} />
        <SubscriptionHistoryCard setSubHistoryModal={setSubHistoryModal} />
        <SubscriptionHistoryCard setSubHistoryModal={setSubHistoryModal} />
        <SubscriptionHistoryCard setSubHistoryModal={setSubHistoryModal} />
        <SubscriptionHistoryCard setSubHistoryModal={setSubHistoryModal} />
        <SubscriptionHistoryCard setSubHistoryModal={setSubHistoryModal} />
        <SubscriptionHistoryCard setSubHistoryModal={setSubHistoryModal} />
      </div>

      {SubHistoryModal ? (
        <SubscriptionHistoryModal
          CloseModal={() => setSubHistoryModal(false)}
        />
      ) : null}
    </div>
  );
};

export default SubscriptionHistory;
